import { render, staticRenderFns } from "./scoretable.vue?vue&type=template&id=21ed6c24&scoped=true"
import script from "./scoretable.vue?vue&type=script&lang=js"
export * from "./scoretable.vue?vue&type=script&lang=js"
import style0 from "./scoretable.vue?vue&type=style&index=0&id=21ed6c24&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21ed6c24",
  null
  
)

export default component.exports